module.exports = __webpack_public_path__ + "img/computer_open.b931219e.svg";